export default __webpack_public_path__ + "static/media/AG15.400446ca.mp3";